import classNames from 'classnames';
import React from 'react';

import styles from './SetupIPACategoryLevelsCategoryLevelsMessage.module.scss';

interface SetupIPACategoryLevelsCategoryLevelsProps {
  children: React.ReactNode;
  className?: string;
}

export const SetupIPACategoryLevelsCategoryLevelsMessage = ({ children, className }: SetupIPACategoryLevelsCategoryLevelsProps) => {
  return <div className={classNames(styles.container, className)}>{children}</div>;
};
